import config from 'config';
import { useRouter } from 'next/router';

import useLocalizedConfig from '~/shared/utils/useLocalizedConfig';
import { useMembership } from '~/techstyle-shared/react-accounts';

export default function useLoyaltyPricing(product) {
  const { isVip } = useMembership();
  const isRewardsPDPEnabled = config.get(
    'public.brand.features.rewardsPDPenabled'
  );
  const { query } = useRouter();
  const rewardsValue = query.rewards_tier_value || '';
  const rewardsIndex = query.rewards_tier_index || '';
  const isRewardsReferred = rewardsValue.length && rewardsIndex.length && isVip;
  const rewardsLevelsFPLsData = {
    ...useLocalizedConfig('public.rewardsLevelFPLs'),
    ...(config.get('public.rewardsLevelFPLs.global') || {}),
  };
  // a List of all FPL Keys, without Point Level data
  const rewardsLevelsFPLKeys = Object.keys(rewardsLevelsFPLsData);
  let productLoyaltyValue = 0;
  let isLoyaltyItem = false;

  if (isRewardsPDPEnabled && isRewardsReferred) {
    // retrieve FPL IDs from the current product
    const productFPLs =
      product && product.featuredProductLocationIdList
        ? product.featuredProductLocationIdList
        : [];

    const productFPLKeys = [
      ...productFPLs,
      ...(product?.activeFeaturedProductLocationCodeList || []).map(
        (item) => item.featuredProductLocationCode
      ),
    ];

    // find a match and return it, hello
    const productRewardsItem = productFPLKeys.find((val) => {
      return rewardsLevelsFPLKeys.includes(val.toString());
    });

    // get the Points value of the match
    productLoyaltyValue = productRewardsItem
      ? rewardsLevelsFPLsData[productRewardsItem]
      : 0;
    isLoyaltyItem = Boolean(productLoyaltyValue && productLoyaltyValue > 0);
  }

  return {
    productLoyaltyValue,
    isLoyaltyItem,
  };
}
